import React, { useEffect, useRef, useState } from "react";
import axios, { CancelToken } from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersSlash } from "@fortawesome/pro-solid-svg-icons";
import { faClock } from "@fortawesome/pro-regular-svg-icons";
import { StatusCode } from "api/protocols";
import "./teeOnPortalBooking.scss";
import OrderSummaryLineItem from "components/bookingEngine/orderSummaryLineItem/OrderSummaryLineItem";
import { useHistory } from "react-router";
import { UserActive } from "api/rpc";
import { dequeue, enqueue, showError, showSuccess } from "redux/actions/ui";
import Card from "components/card/Card";
import Form from "components/form/Form";
import FormLayout from "components/form/FormLayout";
import Radio from "components/radio";
import BookingTimer from "components/bookingEngine/bookingTimer/bookingTimer";
import Checkbox from "components/form/checkbox/Checkbox";
import ReactDOM from "react-dom";
import { Select } from "components/select/index";
import Sheet from "components/sheet/Sheet";
import CardSection from "components/cardSection/CardSection";
import {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent,
} from "@stripe/stripe-js";
import { CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe } from "@stripe/react-stripe-js";
import Markdown from "components/markdown/Markdown";
import { LocaleCurrency } from "helpers/Locale";
import Spin from "components/spin/spin";
import { IBookingParticipant } from "redux/reducers/models/teetime";
import GolferCard from "components/bookingPopUp/golferCard/GolferCard";
import Popup from "components/popup/Popup";
import validator from "validator";
import { useAppDispatch } from "hooks/redux";
import moment from "moment";
import { PostCustomerBooking } from "api/rpc/2024-04/booking";
import { GetCart, PutCart } from "api/rpc/2024-04/cart";
import {
  GetCustomerFriends,
  GetCustomerPaymentMethods,
  ICustomerFriend,
  PostFriends,
  SearchCustomer,
} from "api/rpc/2024-04/customer/customer";
import { ITaxLine } from "components/OrderSummary/OrderSummary";
import { IOrder } from "pages/guest/models/order";
import { PostPaymentMethod, PostSetup } from "api/rpc/2024-04/customer/paymentMethod";
import { GetLeagueParticipants } from "api/rpc/2024-04/customer/league";
import { DeleteLockTeeTime } from "api/rpc/2024-04/customer/teetime";
import { PostCart, PostCheckout, PostLineItemToCart } from "api/rpc/2024-04/guest/cart";
import { PostTransaction, PutCapture } from "api/rpc/2024-04/guest/transaction";
import { PutCompleteOrder } from "api/rpc/guest/order";
import Panel from "components/panel/Panel";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import { useClientPortal } from "../../ClientPortal/useClientPortal";
import ClientPortalBookingCard from "../../ClientPortal/Booking/ClientPortalBookingCard";
import { useTeeOnPortalContext } from "../TeeOnPortalContext";
import { formatDateFromString } from "helpers/Helpers";
import { useTranslation } from "react-i18next";
import Callout from "components/callout/Callout";

interface ITeeOnPortalBookingState {
  holeAmount: number;
  golferAmount: number;
  powerCartAmount: number;
  teeTimeLockExpire: string;
  customerCreditCards: Array<Record<string, any>>;
  customerGiftCards: Array<Record<string, any>>;
  customerRainChecks: Array<Record<string, any>>;
  selectedCardId: number;
  selectedCard: Record<string, any>;
  acceptTerms: boolean;
  newCardActive: boolean;
  saveCard: boolean;
  paymentTermsActive: boolean;
  elementComplete: {
    cardNumber: boolean;
    cardExpiry: boolean;
    cardCvc: boolean;
  };
  cart: Record<string, any>;
  loadPutCart: boolean;

  bookingParticipants: Array<Partial<IBookingParticipant>>;
  player2: string;
  player3: string;
  player4: string;
  friendsSearchResult2: Array<ICustomerFriend>;
  friendsSearchResult3: Array<ICustomerFriend>;
  friendsSearchResult4: Array<ICustomerFriend>;
  newPlayerQuery: string;
  selectedNewPlayer: ICustomerFriend;
  addPlayerModalVisible: boolean;
  searching: boolean;
  customerSearchResult: Array<ICustomerFriend>;
  friendsList: Array<ICustomerFriend>;
  leagueParticipantList: Array<Record<string, any>>;
  disableSingleBooking: boolean;
  [key: string]: any;
}

export interface ITeeTimeState {
  activeUser: boolean;
}

interface IPrepaidWarning {
  title: string;
  description: string;
  open: boolean;
}

export enum PaymentStep {
  post_cart = 1,
  post_line_item = 2,
  post_checkout = 3,
  post_transaction = 4,
  confirm_stripe_payment = 5,
  put_capture = 6,
  put_order_complete = 7,
  post_booking = 8,
}

export interface ITeeOnPortalPaymentState {
  step: PaymentStep;
  cartToken: string;
  order: IOrder;
  transactionId: number;
  clientSecret: string;
  paymentIntent: Record<string, any>;
}

interface IAddFriendState {
  friendsToAdd: Array<Partial<IBookingParticipant>>;
  modalVisible: boolean;
  selectedPlayerIds: Array<number>;
}

export default function TeeOnPortalBooking() {
  const history = useHistory();
  const { teeOnPortalState, updateTeeOnPortal } = useTeeOnPortalContext();
  const dispatch = useAppDispatch();
  const { Option } = Select;
  const loadedPaymentMethods = useRef(false);
  const windowSize = useWindowSize();
  const { t } =useTranslation();

  const stripe = useStripe();
  const elements = useElements();

  const [activeUser, setActiveUser] = useState(false);
  const [holeButtons, setHoleButtons] = useState([true, true]);
  const [loadingComplete, setLoadingComplete] = useState(false);
  const [displayRestricted, setDisplayRestricted] = useState<boolean>(true);


  const { getSingleBookings } = useClientPortal();

  const [addFriendState, setAddFriendState] = useState<IAddFriendState>({
    friendsToAdd: [],
    modalVisible: false,
    selectedPlayerIds: [],
  });

  const [prepaidWarning, setPrepaidWarning] = useState<IPrepaidWarning>({
    title: "",
    description: "",
    open: false,
  });

  const [bookingState, setBookingState] = useState<ITeeOnPortalBookingState>({
    holeAmount: 18,
    golferAmount: 1,
    powerCartAmount: 0,
    teeTimeLockExpire: "",
    customerCreditCards: [],
    customerGiftCards: [],
    customerRainChecks: [],
    selectedCardId: undefined,
    selectedCard: undefined,
    acceptTerms: false,
    newCardActive: false,
    saveCard: false,
    paymentTermsActive: false,
    elementComplete: {
      cardNumber: false,
      cardExpiry: false,
      cardCvc: false,
    },
    cart: null,
    loadPutCart: false,
    bookingParticipants: [],
    player2: "",
    player3: "",
    player4: "",
    friendsSearchResult2: [],
    friendsSearchResult3: [],
    friendsSearchResult4: [],
    newPlayerQuery: "",
    selectedNewPlayer: null,
    addPlayerModalVisible: false,
    searching: false,
    customerSearchResult: [],
    friendsList: [],
    leagueParticipantList: [],
    disableSingleBooking: false,
  });

  const [paymentState, setPaymentState] = useState<ITeeOnPortalPaymentState>({
    step: PaymentStep.post_cart,
    cartToken: null,
    order: null,
    transactionId: null,
    clientSecret: null,
    paymentIntent: null,
  });

  useEffect(() => {
    if (
      teeOnPortalState?.user == null ||
      teeOnPortalState?.selectedTeeTime?.teeTime == null ||
      teeOnPortalState?.selectedTeeTime?.facility == null
    ) {
      //Page was refreshed, return to home page
      void returnToHomePage(true);
    } else {
      void getCustomerLoggedIn();
      void getCart();
      void disableHoles();
      //Get the customer's payment methods
      if (
        teeOnPortalState?.selectedTeeTime?.teeTime?.credit_card_required ||
        teeOnPortalState?.selectedTeeTime?.teeTime?.pre_paid_required
      ) {
        void getCustomerPaymentMethods(teeOnPortalState?.selectedTeeTime?.facility?.client_id);
        loadedPaymentMethods.current = true;
      }

      //Get league participants if selected time is a league time, else get friends list
      if (teeOnPortalState?.selectedTeeTime?.teeTime?.league_id) {
        void getLeagueParticipants();
      } else {
        void getFriendsList();
      }
      setBookingState(prevState => ({
        ...prevState,
        disableSingleBooking: getSingleBookings(
          teeOnPortalState?.selectedTeeTime?.facility?.teeSheetSettings?.single_bookings,
          teeOnPortalState?.selectedTeeTime?.teeTime?.quantity_remaining,
        ).disable,
        golferAmount: getSingleBookings(
          teeOnPortalState?.selectedTeeTime?.facility?.teeSheetSettings?.single_bookings,
          teeOnPortalState?.selectedTeeTime?.teeTime?.quantity_remaining,
        ).golferAmount,
        powerCartAmount: teeOnPortalState?.selectedTeeTime?.teeTime?.cart_rule === "required" ? 1 : 0,
        teeTimeLockExpire: teeOnPortalState?.selectedTeeTime?.lock?.expireTime,
        bookingParticipants: [
          { customer_id: teeOnPortalState?.user?.id, full_name: teeOnPortalState?.user?.full_name },
        ],
      }));
      window.scrollTo({ top: 0, left: 0 });
    }
  }, []);

  useEffect(() => {
    if (!loadedPaymentMethods.current && bookingState?.cart?.total_price_due) {
      void getCustomerPaymentMethods(teeOnPortalState?.selectedTeeTime?.facility?.client_id);
      loadedPaymentMethods.current = true;
    }
  }, [bookingState?.cart?.total_price_due]);

  useEffect(() => {
    if (teeOnPortalState?.selectedTeeTime?.teeTime) {
      void disableHoles();
    }
  }, [bookingState.golferAmount, teeOnPortalState?.selectedTeeTime?.teeTime]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    async function updateCart() {
      updateBookingState({ loadPutCart: true });
      const customerIds = [
        ...bookingState.bookingParticipants.map(participant => participant.customer_id),
        ...new Array(Math.abs(bookingState.golferAmount - bookingState.bookingParticipants.length)).fill(
          teeOnPortalState.user.id,
        ),
      ];
      await PutCart(
        {
          cart_token: localStorage.getItem(
            `$tee_on_portal_${teeOnPortalState?.selectedTeeTime?.facility?.short_name}_booking_engine_cart_token`,
          ),
          tee_time_id: teeOnPortalState?.selectedTeeTime?.teeTime?.id,
          holes: bookingState.holeAmount,
          quantity: bookingState.golferAmount,
          power_cart_quantity: bookingState.powerCartAmount,
          customer_ids: customerIds,
        },
        false,
        source.token,
      )
        .then(data => {
          if (data.data === "Cancelled") {
            updateBookingState({ cart: null, loadPutCart: false });
          } else {
            updateBookingState({ cart: data.data, loadPutCart: false });
          }
        })
        .catch(err => {
          dispatch(showError(err.message as string));
          updateBookingState({ cart: null, loadPutCart: false });
          return;
        });
    }
    // Update the cart line items on load & when a selection is made
    if (
      localStorage.getItem(
        `$tee_on_portal_${teeOnPortalState?.selectedTeeTime?.facility?.short_name}_booking_engine_cart_token`,
      ) &&
      bookingState.holeAmount &&
      bookingState.golferAmount &&
      bookingState.powerCartAmount != null &&
      teeOnPortalState?.selectedTeeTime?.teeTime &&
      loadingComplete
    ) {
      void updateCart();
    }

    return () => {
      source.cancel("Cancelled");
    };
  }, [
    bookingState.holeAmount,
    bookingState.golferAmount,
    bookingState.powerCartAmount,
    loadingComplete,
    localStorage.getItem(
      `$tee_on_portal_${teeOnPortalState?.selectedTeeTime?.facility?.short_name}_booking_engine_cart_token`,
    ),
    bookingState?.bookingParticipants,
  ]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    let mounted = true;
    let timeoutId: NodeJS.Timeout = null;
    if (mounted === true) {
      timeoutId = setTimeout(() => {
        void search(bookingState.newPlayerQuery, "customerSearchResult", source.token);
      }, 500);
    }
    return () => {
      source.cancel("Cancelled");
      mounted = false;
      clearTimeout(timeoutId);
      setBookingState(prevState => ({ ...prevState, customerSearchResult: [] }));
    };
  }, [bookingState.newPlayerQuery]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    let mounted = true;
    let timeoutId: NodeJS.Timeout = null;
    if (mounted === true) {
      timeoutId = setTimeout(() => {
        void search(bookingState.player2, "friendsSearchResult2", source.token);
      }, 500);
    }
    return () => {
      source.cancel("Cancelled");
      mounted = false;
      clearTimeout(timeoutId);
      setBookingState(prevState => ({ ...prevState, friendsSearchResult2: [] }));
    };
  }, [bookingState.player2]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    let mounted = true;
    let timeoutId: NodeJS.Timeout = null;
    if (mounted === true) {
      timeoutId = setTimeout(() => {
        void search(bookingState.player3, "friendsSearchResult3", source.token);
      }, 500);
    }
    return () => {
      source.cancel("Cancelled");
      mounted = false;
      clearTimeout(timeoutId);
      setBookingState(prevState => ({ ...prevState, friendsSearchResult3: [] }));
    };
  }, [bookingState.player3]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    let mounted = true;
    let timeoutId: NodeJS.Timeout = null;
    if (mounted === true) {
      timeoutId = setTimeout(() => {
        void search(bookingState.player4, "friendsSearchResult4", source.token);
      }, 500);
    }
    return () => {
      source.cancel("Cancelled");
      mounted = false;
      clearTimeout(timeoutId);
      setBookingState(prevState => ({ ...prevState, friendsSearchResult4: [] }));
    };
  }, [bookingState.player4]);

  function updateBookingState(newBookingState: Partial<ITeeOnPortalBookingState>) {
    setBookingState(cur => {
      return { ...cur, ...newBookingState };
    });
  }

  // Check if card inputs are filled
  const elementsComplete =
    bookingState.elementComplete.cardNumber === true &&
    bookingState.elementComplete.cardExpiry === true &&
    bookingState.elementComplete.cardCvc === true;

  const orderSummaryObjects = [
    {
      lineItem: t("Date"),
      itemValue: moment(teeOnPortalState?.selectedTeeTime?.teeTime?.date).format("LL"),
    },
    {
      lineItem: t("Time"),
      itemValue: moment(teeOnPortalState?.selectedTeeTime?.teeTime?.start_time, "hh:mm").format("LT"),
    },
    {
      lineItem: t("No. Holes"),
      itemValue: bookingState.holeAmount,
    },
    {
      lineItem: t("No. Golfers"),
      itemValue: bookingState.golferAmount,
    },
    {
      lineItem: t("No. Carts"),
      itemValue: bookingState.powerCartAmount,
    },
  ];

  const search = async (playerSearchQuery: string, playerSearchResult: string, cancelToken: CancelToken) => {
    try {
      if (playerSearchQuery === "") {
        setBookingState(prevState => ({ ...prevState, [playerSearchResult]: [] }));
        return;
      } else {
        setBookingState(prevState => ({ ...prevState, searching: true }));
        let friendsResults: any;
        if (playerSearchResult === "customerSearchResult") {
          friendsResults = await searchCustomers(cancelToken);
        } else {
          friendsResults = await searchFriends(playerSearchQuery, cancelToken);
        }
        setBookingState(prevState => ({ ...prevState, searching: false, [playerSearchResult]: friendsResults }));
      }
    } catch (error) {
      console.log("err", error);
    }
    return;
  };

  async function getFriendsList() {
    const friendsListRes = await GetCustomerFriends(
      { facility_id: teeOnPortalState?.selectedTeeTime?.facility?.id },
      true,
    );
    if (friendsListRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error getting friends list")));
      return;
    }
    setBookingState(prevState => ({ ...prevState, friendsList: friendsListRes.data }));
  }

  async function getLeagueParticipants() {
    const leagueParticipantRes = await GetLeagueParticipants(
      { league_id: teeOnPortalState?.selectedTeeTime?.teeTime?.league_id },
      true,
    );
    if (leagueParticipantRes?.status !== StatusCode.OK) {
      dispatch(showError(t("Error getting league participants")));
      return;
    }

    const filteredLeagueParticipants = leagueParticipantRes?.data?.filter(
      (participant: Record<string, any>) => participant?.user_id !== teeOnPortalState?.user?.id,
    );
    setBookingState(prevState => ({ ...prevState, leagueParticipantList: filteredLeagueParticipants }));
  }

  async function searchCustomers(cancelToken: CancelToken) {
    let searchCustomersRes;
    const phoneNumberFormats = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(bookingState?.newPlayerQuery);
    if (
      validator.isEmail(bookingState?.newPlayerQuery) ||
      validator.isMobilePhone(bookingState?.newPlayerQuery) ||
      validator.isNumeric(bookingState?.newPlayerQuery) ||
      phoneNumberFormats
    ) {
      searchCustomersRes = await SearchCustomer(
        {
          search: bookingState.newPlayerQuery,
          client_id: teeOnPortalState?.selectedTeeTime?.facility?.client_id,
          facility_id: teeOnPortalState?.selectedTeeTime?.facility?.id,
        },
        false,
        cancelToken,
      );
    } else {
      searchCustomersRes = await SearchCustomer(
        {
          member_search: bookingState.newPlayerQuery,
          client_id: teeOnPortalState?.selectedTeeTime?.facility?.client_id,
          facility_id: teeOnPortalState?.selectedTeeTime?.facility?.id,
        },
        false,
        cancelToken,
      );
      searchCustomersRes.data = searchCustomersRes?.data?.filter(
        (customer: Record<string, any>) => !customer?.customer_type[0]?.default,
      );
    }

    if (searchCustomersRes.status !== StatusCode.OK) {
      if (searchCustomersRes.message !== "Cancelled") {
        dispatch(showError(t("Error getting customers")));
      }
      return [];
    }
    return searchCustomersRes.data as Array<ICustomerFriend>;
  }

  async function searchFriends(playerSearchQuery: string, cancelToken: CancelToken) {
    const searchFriendsRes = await GetCustomerFriends(
      { search: playerSearchQuery, facility_id: teeOnPortalState?.selectedTeeTime?.facility?.id },
      false,
      cancelToken,
    );
    if (searchFriendsRes.status !== StatusCode.OK) {
      if (searchFriendsRes.message !== "Cancelled") {
        dispatch(showError(t("Error getting friends list")));
      }
      return [];
    }
    return searchFriendsRes.data;
  }

  async function getCart() {
    //Create a new cart if there is no customer cart token in local storage
    if (
      !localStorage.getItem(
        `$tee_on_portal_${teeOnPortalState?.selectedTeeTime?.facility?.short_name}_booking_engine_cart_token`,
      )
    ) {
      const getCartRes = await GetCart(
        {
          facility_id: teeOnPortalState?.selectedTeeTime?.facility?.id,
          token: localStorage.getItem(
            `$tee_on_portal_${teeOnPortalState?.selectedTeeTime?.facility?.short_name}_booking_engine_cart_token`,
          ),
        },
        true,
      );
      if (getCartRes.status !== StatusCode.OK) {
        dispatch(showError(t("Error getting cart")));
        return;
      }

      //Set new customer cart token
      localStorage.setItem(
        `$tee_on_portal_${teeOnPortalState?.selectedTeeTime?.facility?.short_name}_booking_engine_cart_token`,
        getCartRes.data.token as string,
      );

      updateBookingState({ cart: getCartRes.data });
    }
  }

  async function getCustomerLoggedIn() {
    // Check if user is logged in
    if (teeOnPortalState?.user == null) {
      dispatch(enqueue());
      const activeUserRes = await UserActive(false);
      dispatch(dequeue());
      if (activeUserRes.status === StatusCode.OK) {
        ReactDOM.unstable_batchedUpdates(() => {
          setActiveUser(true);
          updateTeeOnPortal({ user: activeUserRes?.data });
          updateBookingState({
            customerFirstName: activeUserRes.data.first_name,
            customerLastName: activeUserRes.data.last_name,
            customerEmail: activeUserRes.data.email,
            customerPhone: activeUserRes.data.phone,
          });
        });
      } else {
        //User is not logged in, send them back to the home page
        setActiveUser(false);
        dispatch(showError(t("User is not logged in. Please log in and try again.")));
        void returnToHomePage(false);
      }
    } else {
      setActiveUser(true);
    }
  }

  function handleHoleChange(holeAmount: number) {
    updateBookingState({ holeAmount });
  }

  function handleGolferAmountChange(golferAmount: number) {
    if (golferAmount < bookingState.golferAmount) {
      void handleRemoveGolfers(golferAmount);
    }

    updateBookingState({
      golferAmount: golferAmount,
    });
  }

  function handleCartChange(cartAmount: number) {
    updateBookingState({ powerCartAmount: cartAmount });
  }

  function handleRemoveGolfers(newQuantity: number) {
    const updatedBookingParticipants = [...bookingState.bookingParticipants].filter(
      (participant, index) => index + 1 <= newQuantity,
    );

    setBookingState(prevState => ({
      ...prevState,
      bookingParticipants: updatedBookingParticipants,
      player2: "",
      player3: "",
      player4: "",
    }));
  }

  async function returnToHomePage(deleteLock: boolean) {
    const facility = teeOnPortalState?.selectedTeeTime?.facility;
    if (deleteLock) {
      const deleteLockTeeTimeRes = await DeleteLockTeeTime(true);
      if (deleteLockTeeTimeRes?.status !== StatusCode.OK) {
        console.error(deleteLockTeeTimeRes?.data ?? "Error deleting lock");
      }
    }
    updateTeeOnPortal({ selectedTeeTime: null });
    history.push(`/booking/teetimes${facility ? "/".concat(facility?.short_name) : ""}`);
  }

  async function getCustomerPaymentMethods(clientId: number) {
    const customerPaymentMethodsRes = await GetCustomerPaymentMethods(
      { client_id: clientId, type: ["card", "gift_card", "rain_check"] },
      true,
    );
    if (customerPaymentMethodsRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error getting customer payment methods")));
      return;
    }
    updateBookingState({
      customerCreditCards: customerPaymentMethodsRes.data?.card,
      customerGiftCards: customerPaymentMethodsRes.data?.gift_card,
      customerRainChecks: customerPaymentMethodsRes.data?.rain_check,
      selectedCardId:
        customerPaymentMethodsRes.data?.card?.length >= 1 ? customerPaymentMethodsRes.data?.card[0]?.id : undefined,
      selectedCard:
        customerPaymentMethodsRes.data?.card?.length >= 1 ? customerPaymentMethodsRes.data?.card[0] : undefined,
    });
  }

  function handleCardDropDownChange(value: number, id: string, card: Record<string, any>) {
    setBookingState(prevState => ({ ...prevState, [id]: value, selectedCard: card ? card : prevState.selectedCard }));
  }

  function handleCheckboxChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { id, checked } = e.target;
    updateBookingState({ [id]: checked });
  }

  function handleAddPlayerCheckbox(participantId: number) {
    const addedPlayerIds = [...addFriendState.selectedPlayerIds];
    const foundIndex = addedPlayerIds?.indexOf(participantId);
    if (foundIndex === -1) {
      addedPlayerIds?.push(participantId);
    } else {
      addedPlayerIds?.splice(foundIndex, 1);
    }
    setAddFriendState(prevState => ({ ...prevState, selectedPlayerIds: addedPlayerIds }));
  }

  function disableCheckout() {
    //User hasn't accepted the payment terms and conditions
    if (!bookingState.acceptTerms) {
      return true;
    }
    // # of holes, # of players or # of power carts has not been selected
    if (!bookingState.holeAmount || !bookingState.golferAmount || bookingState.powerCartAmount == null) {
      return true;
    }

    // Cart is loading
    if (bookingState.loadPutCart || bookingState.cart === null) {
      return true;
    }

    //Credit card has not been selected
    if (
      bookingState.cart?.credit_card_required ??
      teeOnPortalState?.selectedTeeTime?.teeTime?.credit_card_required
    ) {
      if (bookingState.selectedCardId == null) {
        return true;
      }
    }

    //Credit card has not been selected (payment required)
    if (teeOnPortalState?.selectedTeeTime?.teeTime?.pre_paid_required || bookingState?.cart?.total_price_due) {
      if (bookingState.selectedCardId == null) {
        return true;
      }
    }

    return false;
  }

  function disableHoles() {
    const tempHoleButtons = [true, true];
    // Disabling holes
    teeOnPortalState?.selectedTeeTime?.teeTime?.divisions_available?.forEach(division => {
      // 9 holes available
      if (division === 1) {
        tempHoleButtons[1] = false;
      } else if (division === 2) {
        if (
          (teeOnPortalState?.selectedTeeTime?.teeTime?.divisions_available?.length > 1 &&
            teeOnPortalState?.selectedTeeTime?.teeTime?.turn_tee_time === null) ||
          teeOnPortalState?.selectedTeeTime?.teeTime?.turn_tee_time?.blocked_type === "blocked" ||
          ((teeOnPortalState?.selectedTeeTime?.teeTime?.turn_tee_time?.league_id ||
            teeOnPortalState?.selectedTeeTime?.teeTime?.turn_tee_time?.tournament_id) &&
            (teeOnPortalState?.selectedTeeTime?.teeTime?.league_id !==
              teeOnPortalState?.selectedTeeTime?.teeTime?.turn_tee_time?.league_id ||
              teeOnPortalState?.selectedTeeTime?.teeTime?.tournament_id !==
                teeOnPortalState?.selectedTeeTime?.teeTime?.turn_tee_time?.tournament_id))
        ) {
          // Only 9 holes available
          tempHoleButtons[1] = false;
        } else if (teeOnPortalState?.selectedTeeTime?.teeTime?.turn_tee_time != null) {
          // 18 holes available
          if (
            teeOnPortalState?.selectedTeeTime?.teeTime?.quantity_remaining >= bookingState.golferAmount &&
            teeOnPortalState?.selectedTeeTime?.teeTime?.turn_tee_time?.quantity_remaining >= bookingState.golferAmount
          ) {
            tempHoleButtons[0] = false;
          } else {
            // Only 9 holes available
            tempHoleButtons[1] = false;
          }
        }
      }
    });

    if (tempHoleButtons[0] && tempHoleButtons[1]) {
      updateBookingState({ holeAmount: null });
    } else if (tempHoleButtons[0]) {
      updateBookingState({ holeAmount: 9 });
    } else if (tempHoleButtons[1]) {
      updateBookingState({ holeAmount: 18 });
    }
    setHoleButtons(tempHoleButtons);
    if (!loadingComplete) {
      setLoadingComplete(true);
    }
  }

  function openNewCardModal() {
    updateBookingState({ newCardActive: true });
  }

  function handleCardSectionChange(
    e: StripeCardNumberElementChangeEvent | StripeCardExpiryElementChangeEvent | StripeCardCvcElementChangeEvent,
  ) {
    updateBookingState({
      elementComplete: { ...bookingState.elementComplete, [e.elementType]: e.complete },
    });
  }

  async function handleAddNewCard() {
    if (!stripe || !elements) {
      dispatch(showError(t("Error occurred before card could save. Please reattempt.")));
      return;
    }
    const tempCreditCards = [...bookingState.customerCreditCards];
    dispatch(enqueue());
    try {
      const stripePaymentMethodRes = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement("cardNumber"),
      });

      if (stripePaymentMethodRes.paymentMethod) {
        const setupRes = await PostSetup(false);

        if (setupRes.status !== StatusCode.OK) {
          dispatch(showError(t("Error setting up card")));
        }
        if (stripePaymentMethodRes.paymentMethod.id !== "undefined" && setupRes.status === StatusCode.OK) {
          const stripeConfirmCardRes = await stripe.confirmCardSetup(
            setupRes.data.setup_intent.client_secret as string,
            {
              payment_method: stripePaymentMethodRes.paymentMethod.id,
            },
          );
          if (stripeConfirmCardRes.error) {
            dispatch(showError(stripeConfirmCardRes.error.message));
          } else {
            const postPaymentRes = await PostPaymentMethod(
              {
                payment_method_id: stripeConfirmCardRes.setupIntent.payment_method,
                save_card: bookingState.saveCard,
                facility_id: teeOnPortalState?.selectedTeeTime?.facility?.id,
              },
              false,
            );
            if (postPaymentRes.status !== StatusCode.OK) {
              dispatch(showError(t("Error adding card")));
            } else {
              tempCreditCards.push(postPaymentRes.data as Record<string, any>);
              updateBookingState({
                customerCreditCards: tempCreditCards,
                selectedCardId: postPaymentRes.data.id,
                selectedCard: postPaymentRes?.data,
              });
              void closeAddNewCard();
              dispatch(showSuccess(t("Successfully added card")));
            }
          }
        }
      } else {
        dispatch(showError(stripePaymentMethodRes.error.message));
      }
    } catch (e) {
      console.error(e);
      dispatch(dequeue());
    }
    dispatch(dequeue());
  }

  function closeAddNewCard() {
    elements.getElement(CardNumberElement).clear();
    elements.getElement(CardExpiryElement).clear();
    elements.getElement(CardCvcElement).clear();
    updateBookingState({ newCardActive: false });
  }

  async function handleCreateBooking() {
    let order = paymentState?.order;
    let currentCartToken = paymentState?.cartToken;
    let clientSecret = paymentState?.clientSecret;
    let transactionId = paymentState?.transactionId;
    let stripePaymentIntent = paymentState?.paymentIntent;

    if (bookingState?.cart?.total_price_due && paymentState?.step < PaymentStep.post_booking) {
      dispatch(enqueue());
      //Create payment cart
      setPrepaidWarning(prevState => ({ ...prevState, open: false }));
      if (paymentState.step <= PaymentStep.post_line_item) {
        const cartRes = await PostCart(
          {
            sales_channel: "booking_engine",
            facility_id: teeOnPortalState?.selectedTeeTime?.facility?.id,
            customer_id: teeOnPortalState?.user?.id,
          },
          false,
        );
        if (cartRes.status !== Number(StatusCode.OK)) {
          setPaymentState(prevState => ({ ...prevState, step: PaymentStep.post_cart }));
          dispatch(showError(t("Error creating cart")));
          dispatch(dequeue());
          return;
        }

        currentCartToken = cartRes?.data?.token;
      }
      if (paymentState.step <= PaymentStep.post_line_item) {
        //Add prepaid line items to the new cart
        for (const lineItem of bookingState.cart.line_items) {
          if (lineItem?.pre_paid_required) {
            const postLineItemRes = await PostLineItemToCart(
              { variant_id: lineItem?.variant_id, cart_token: currentCartToken, quantity: lineItem?.quantity },
              false,
            );
            if (postLineItemRes?.status !== Number(StatusCode.OK)) {
              setPaymentState(prevState => ({
                ...prevState,
                step: PaymentStep.post_line_item,
                cartToken: currentCartToken,
              }));
              dispatch(showError(t("Error adding line item to cart")));
              dispatch(dequeue());
              return;
            }
          }
        }
      }

      if (paymentState?.step <= PaymentStep.post_checkout) {
        const postCheckoutRes = await PostCheckout({ cart_token: currentCartToken }, false);
        if (postCheckoutRes.status !== Number(StatusCode.OK)) {
          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.post_checkout,
            cartToken: currentCartToken,
          }));
          dispatch(showError(t("Checkout error")));
          dispatch(dequeue());
          return;
        }
        order = postCheckoutRes.data?.order;

        if (!order?.token) {
          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.post_checkout,
            cartToken: currentCartToken,
          }));
          dispatch(showError(t("Order does not exist")));
          dispatch(dequeue());
          return;
        }
      }

      if (paymentState.step <= PaymentStep.post_transaction) {
        //Process transaction
        const postTransactionRes = await PostTransaction(
          {
            processing_type: "online",
            order_token: order.token,
            kind: "authorization",
            source: "online",
            amount: order.total_price,
            payment_method: "card",
          },
          false,
        );

        clientSecret = postTransactionRes?.data?.client_secret;
        transactionId = postTransactionRes?.data?.id;

        if (postTransactionRes.status !== StatusCode.OK || !clientSecret) {
          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.post_transaction,
            cartToken: currentCartToken,
            order: order,
          }));
          dispatch(showError(t("Error creating transaction")));
          dispatch(dequeue());
          return;
        }
      }

      if (!stripe || !elements) {
        setPaymentState(prevState => ({
          ...prevState,
          step: PaymentStep.confirm_stripe_payment,
          cartToken: currentCartToken,
          order: order,
          clientSecret: clientSecret,
          transactionId: transactionId,
        }));
        dispatch(showError(t("Payment error. Cannot confirm card payments")));
        dispatch(dequeue());
        return;
      }

      if (paymentState?.step <= PaymentStep.confirm_stripe_payment) {
        //Confrim stripe card payment
        const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
          payment_method: bookingState?.selectedCard?.stripe_payment_method_id,
        });

        if (stripeError) {
          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.confirm_stripe_payment,
            cartToken: currentCartToken,
            order: order,
            clientSecret: clientSecret,
            transactionId: transactionId,
          }));
          dispatch(showError(stripeError.message));
          dispatch(dequeue());
          return;
        }
        stripePaymentIntent = paymentIntent;
      }
      if (paymentState?.step <= PaymentStep.put_capture) {
        //Capture card payment
        const putCaptureRes = await PutCapture(
          { payment_intent_id: stripePaymentIntent?.id, transaction_id: transactionId },
          false,
        );

        if (putCaptureRes.status !== StatusCode.OK) {
          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.put_capture,
            cartToken: currentCartToken,
            order: order,
            clientSecret: clientSecret,
            transactionId: transactionId,
            paymentIntent: stripePaymentIntent,
          }));
          dispatch(showError(t("Card capture error")));
          dispatch(dequeue());
          return;
        }
      }

      if (paymentState.step <= PaymentStep.put_order_complete) {
        //Complete Order
        const putCompleteOrderRes = await PutCompleteOrder({ token: order.token }, false);

        if (putCompleteOrderRes.status !== Number(StatusCode.OK)) {
          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.put_order_complete,
            cartToken: currentCartToken,
            order: order,
            clientSecret: clientSecret,
            transactionId: transactionId,
            paymentIntent: stripePaymentIntent,
          }));
          dispatch(showError(t("Error completing order")));
          dispatch(dequeue());
          return;
        }
      }
      dispatch(dequeue());
    }

    setPaymentState(prevState => ({
      ...prevState,
      step: PaymentStep.post_booking,
      cartToken: currentCartToken,
      order: order,
      clientSecret: clientSecret,
      transactionId: transactionId,
      paymentIntent: stripePaymentIntent,
    }));

    await postCustomerBooking(order);
  }

  async function postCustomerBooking(order: IOrder) {
    if (
      !bookingState.acceptTerms ||
      !bookingState.holeAmount ||
      !bookingState.golferAmount ||
      bookingState.powerCartAmount == null
    ) {
      console.log("Booking error, missing holes, players or power cart amount. User may not have accepted terms.");
      return;
    }

    if (
      (bookingState.cart?.credit_card_required ??
        teeOnPortalState?.selectedTeeTime?.teeTime?.credit_card_required) &&
      bookingState.selectedCardId == null
    ) {
      dispatch(showError(t("Booking error, missing payment information")));
      return;
    }

    const lockAllOptions = order && bookingState?.cart?.pre_paid_required ? true : false;
    const lockQuantity =
      order && !bookingState?.cart?.pre_paid_required && bookingState?.cart?.booking_fee_required ? true : false;

    const customerIds = setCustomerIds();

    const params = {
      tee_time_id: teeOnPortalState?.selectedTeeTime?.teeTime?.id,
      holes: bookingState.holeAmount,
      quantity: bookingState.golferAmount,
      power_cart_quantity: bookingState.powerCartAmount,
      customer_payment_method_id: bookingState.selectedCardId,
      accept_payment_terms: bookingState.acceptTerms,
      cart_token: bookingState.cart?.token,
      order_id: order && bookingState?.cart?.pre_paid_required ? order?.id : undefined,
      booking_fee_order_id: order && bookingState?.cart?.booking_fee_required ? order?.id : undefined,
      lock_quantity: lockAllOptions || lockQuantity,
      lock_holes: lockAllOptions,
      lock_power_cart_quantity: lockAllOptions,
      customer_ids: customerIds,
      waitlist_reference_id: teeOnPortalState?.waitlist_reference_id ?? undefined,
    };

    const bookingRes = await PostCustomerBooking(params, true);
    if (bookingRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error creating booking")));
      return;
    }

    updateTeeOnPortal({
      selectedTeeTime: {
        ...teeOnPortalState?.selectedTeeTime,
        booking: { ...bookingRes?.data, paymentMethodId: bookingState.selectedCardId ?? null },
        lock: null,
      },
      waitlist_reference_id: null,
    });

    const bookingToken = bookingRes.data?.token as string;

    localStorage.removeItem(
      `$tee_on_portal_${teeOnPortalState?.selectedTeeTime?.facility?.short_name}_booking_engine_cart_token`,
    );
    const address = `/booking/teetimes/confirm?token=${bookingToken}&facility=${teeOnPortalState?.selectedTeeTime?.facility?.short_name}`;
    history.push(address);
  }

  function setCustomerIds() {
    const customerIds: number[] = bookingState?.bookingParticipants?.map(participant => participant?.customer_id);

    const playerDifference = bookingState.golferAmount - customerIds.length;
    // Fill guest slots
    if (customerIds.length < bookingState.golferAmount) {
      for (let i = 0; i < playerDifference; i++) {
        customerIds.push(teeOnPortalState?.user?.id);
      }
    }
    return customerIds;
  }

  async function checkFriendsToAdd() {
    //Skip adding friends for leagues
    if (!teeOnPortalState?.selectedTeeTime?.teeTime?.league_id) {
      //Display modal to add playing partners that are not in the user's friends list
      const newPlayingPartners = bookingState?.bookingParticipants?.filter(
        participant =>
          participant?.customer_id !== teeOnPortalState?.user?.id &&
          !bookingState?.friendsList?.some(friend => friend?.id === participant?.id),
      );
      if (newPlayingPartners?.length > 0) {
        const addedPlayers = newPlayingPartners?.map(partner => partner?.customer_id);
        setAddFriendState(prevState => ({
          ...prevState,
          friendsToAdd: newPlayingPartners,
          modalVisible: true,
          selectedPlayerIds: addedPlayers,
        }));
        return;
      }
    }
    //Make booking if there are no users in the booking that are outside of the user's friends list
    await handleCreateBooking();
  }

  async function handleAddFriends() {
    const usersToAdd = [...addFriendState.selectedPlayerIds];
    if (usersToAdd?.length > 0) {
      const addRes = await PostFriends({ friend_user_ids: usersToAdd }, true);
      if (addRes?.status !== StatusCode.OK) {
        dispatch(showError(t("Error adding playing partners")));
      } else {
        dispatch(showSuccess(t("Successfully added playing partners")));
      }
    }
    await handleCreateBooking();
  }

  function removeGolferFromBooking(index: number) {
    const updatedBookingParticipants = [...bookingState.bookingParticipants];
    updatedBookingParticipants.splice(index, 1);
    ReactDOM.unstable_batchedUpdates(() => {
      setBookingState(prevState => ({ ...prevState, bookingParticipants: updatedBookingParticipants }));
      setBookingState(prevState => ({ ...prevState, player2: "", player3: "", player4: "" }));
    });
  }

  const handleCustomerSearch = (query: string, name: string) => {
    setBookingState(prevState => ({ ...prevState, [name]: query }));
  };

  function handleCustomerSelection(id: number, friend: Partial<IBookingParticipant>) {
    const updatedBookingParticipants = [...bookingState.bookingParticipants];
    updatedBookingParticipants.push({ ...friend, customer_id: friend?.id });
    setBookingState(prevState => ({
      ...prevState,
      bookingParticipants: updatedBookingParticipants,
      player2: "",
      player3: "",
      player4: "",
      selectedNewPlayer: null,
      addPlayerModalVisible: false,
      newPlayerQuery: "",
      customerSearchResult: [],
      friendsSearchResult2: [],
      friendsSearchResult3: [],
      friendsSearchResult4: [],
    }));
  }

  function handleLeagueParticipantSelection(id: number, participant: Record<string, any>) {
    const updatedBookingParticipants = [...bookingState.bookingParticipants];
    updatedBookingParticipants.push({
      ...participant,
      customer_id: participant?.user_id,
      full_name: participant?.customer?.full_name,
    });
    setBookingState(prevState => ({
      ...prevState,
      bookingParticipants: updatedBookingParticipants,
      leagueParticipantQuery_2: "",
      leagueParticipantQuery_3: "",
      leagueParticipantQuery_4: "",
    }));
  }

  function displayAddPlayerModal() {
    setBookingState(prevState => ({
      ...prevState,
      addPlayerModalVisible: !prevState.addPlayerModalVisible,
      selectedNewPlayer: null,
      newPlayerQuery: "",
      customerSearchResult: [],
    }));
  }

  function renderFriendsList(playerSearchResult: string) {
    //Display the search results if the array contains values
    if (bookingState[playerSearchResult]?.length > 0) {
      return bookingState[playerSearchResult] as Array<ICustomerFriend>;
    } else {
      //Else return the entire friends list
      return bookingState.friendsList;
    }
  }

  function handleNewPlayerSelection(id: string, friend: any) {
    setBookingState(prevState => ({ ...prevState, selectedNewPlayer: friend }));
  }

  function removeNewPlayerSelection() {
    setBookingState(prevState => ({ ...prevState, selectedNewPlayer: null, newPlayerQuery: "" }));
  }

  function displayBookingFeeWarning() {
    setPrepaidWarning(prevState => ({
      ...prevState,
      open: true,
      title: t("Booking Fee Charge"),
      description:
        t("This tee time has non refundable booking fees that will be charged to your selected credit card. Do you wish to continue with this booking?"),
    }));
  }

  function displayPrePaidWarning() {
    setPrepaidWarning(prevState => ({
      ...prevState,
      open: true,
      title: t("Pre Paid Charge"),
      description: t("This tee time is pre paid and your selected credit card will be charged. Do you wish to continue?"),
    }));
  }

  function searchLeagueParticipant(searchString: string, index: number) {
    setBookingState(prevState => ({ ...prevState, [`leagueParticipantQuery_${index + 1}`]: searchString }));
  }

  function displayTerms(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    updateBookingState({ paymentTermsActive: true });
  }

  const bookingFeePaid =
    (paymentState?.step >= PaymentStep.put_order_complete &&
      paymentState?.step <= PaymentStep.post_booking &&
      bookingState?.cart?.total_price_due) ||
    !!paymentState?.order;

  return (
    activeUser &&
    loadingComplete && (
      <>
        <div className="tee-on-booking-portal-booking-background">
          <div className="tee-on-booking-portal-booking-timer-container">
            <div className="tee-on-booking-portal-booking-timer-facility-container">
              <span className="tee-on-booking-portal-booking-timer-course-logo">
                {teeOnPortalState?.selectedTeeTime?.facility?.logo_source && (
                  <img
                    className="tee-on-booking-portal-booking-timer-course-logo"
                    src={teeOnPortalState?.selectedTeeTime?.facility?.logo_source}
                    alt={t("Facility Logo")}
                  />
                )}
              </span>
              <div className="flex flex-col gap-1">
                <p className="tee-on-booking-portal-booking-timer-course-name">
                  {teeOnPortalState?.selectedTeeTime?.facility?.long_name}
                </p>
                {teeOnPortalState?.selectedTeeTime?.facility && (
                  <p className="tee-on-booking-portal-booking-timer-address">
                    {`${teeOnPortalState?.selectedTeeTime?.facility?.address_line_1}, ${teeOnPortalState?.selectedTeeTime?.facility?.city}, ${teeOnPortalState?.selectedTeeTime?.facility?.province_name}, ${teeOnPortalState?.selectedTeeTime?.facility?.postal}`}
                  </p>
                )}
              </div>
            </div>
            <div className="tee-on-booking-portal-booking-timer-duration-container">
              <FontAwesomeIcon
                className="tee-on-booking-portal-booking-timer-icon"
                size="1x"
                color="#999999"
                icon={faClock}
              />
              <span className="tee-on-booking-portal-booking-timer-address">{"Time left to complete booking:"}</span>
              <span className="tee-on-booking-portal-booking-timer-duration-countdown">
                <BookingTimer
                  expireTime={teeOnPortalState?.selectedTeeTime?.lock?.expireTime}
                  teeTimeExpiryUrl={`/booking/teetimes${
                    teeOnPortalState?.selectedTeeTime?.facility
                      ? "/".concat(teeOnPortalState?.selectedTeeTime?.facility?.short_name)
                      : ""
                  }`}
                  active={true}
                />
              </span>
            </div>
          </div>
          <div className="tee-on-booking-portal-booking-main-container">
            <div className="tee-on-booking-portal-booking-main-container-left-side">
              <Card>
                <Card.Section>
                {teeOnPortalState?.selectedTeeTime?.teeTime?.is_restricted && displayRestricted ? (
                <><Callout type={"error"} title={t("Your member rate is restricted for this tee time")} content={t("By continuing booking, you will pay the regular fee rate.")} actions={{primary: {label: t("Continue with regular fee"), onClick: () => setDisplayRestricted(false), buttonType: "error"}, secondary: {label: t("Choose a different tee time"), onClick: () => returnToHomePage(true)}}} /> <br/></>
              ) : null}
                  <p className="tee-on-booking-portal-booking-booking-details-selection-start-time">
                    {moment(teeOnPortalState?.selectedTeeTime?.teeTime?.start_time, "hh:mm:ss").format("h:mm A")}
                  </p>
                  <p className="tee-on-booking-portal-booking-booking-details-selection-date">
                    {formatDateFromString(teeOnPortalState?.selectedTeeTime?.teeTime?.date ?? "")}
                  </p>

                  <div className="tee-on-booking-portal-booking-booking-details-selection-container">
                    <div className="tee-on-booking-portal-booking-booking-details-selection-button-group">
                      <p className="tee-on-booking-portal-booking-booking-details-selection-title">{t("Holes")}</p>
                      <Radio.Group name="number_of_holes" onChange={handleHoleChange} value={bookingState.holeAmount}>
                        <Radio.Button value={18} disabled={holeButtons[0] || bookingFeePaid}>
                          <span className="mr-2">18</span>
                          <FontAwesomeIcon size="1x" icon={["far", "golf-flag-hole"]} />
                        </Radio.Button>
                        <Radio.Button value={9} disabled={holeButtons[1] || bookingFeePaid}>
                          <span className="mr-2">9</span>
                          <FontAwesomeIcon size="1x" icon={["far", "golf-flag-hole"]} />
                        </Radio.Button>
                      </Radio.Group>
                    </div>

                    <div className="tee-on-booking-portal-booking-booking-details-selection-button-group">
                      <p className="tee-on-booking-portal-booking-booking-details-selection-title">{t("Players")}</p>
                      <Radio.Group
                        name="number_of_golfers"
                        onChange={handleGolferAmountChange}
                        value={bookingState.golferAmount}
                      >
                        <Radio.Button value={1} disabled={bookingState.disableSingleBooking || bookingFeePaid}>
                          {1}
                        </Radio.Button>
                        <Radio.Button
                          value={2}
                          disabled={
                            teeOnPortalState?.selectedTeeTime?.teeTime?.quantity_remaining < 2 || bookingFeePaid
                              ? true
                              : false
                          }
                        >
                          {2}
                        </Radio.Button>
                        <Radio.Button
                          value={3}
                          disabled={
                            teeOnPortalState?.selectedTeeTime?.teeTime?.quantity_remaining < 3 || bookingFeePaid
                              ? true
                              : false
                          }
                        >
                          {3}
                        </Radio.Button>
                        <Radio.Button
                          value={4}
                          disabled={
                            teeOnPortalState?.selectedTeeTime?.teeTime?.quantity_remaining < 4 || bookingFeePaid
                              ? true
                              : false
                          }
                        >
                          {4}
                        </Radio.Button>
                      </Radio.Group>
                    </div>
                  </div>
                </Card.Section>
              </Card>

              <Card>
                {teeOnPortalState?.selectedTeeTime?.facility?.teeSheetSettings?.enable_cart_bookings ? (
                  <div>
                    {(teeOnPortalState?.selectedTeeTime?.teeTime?.cart_rule === "optional" ||
                      teeOnPortalState?.selectedTeeTime?.teeTime?.cart_rule === "required") && (
                      <Card.Section>
                        <div className="tee-on-booking-portal-booking-booking-details-selection-container">
                          <div
                            style={{ width: "100%" }}
                            className="tee-on-booking-portal-booking-booking-details-selection-button-group"
                          >
                            <p className="tee-on-booking-portal-booking-booking-details-selection-title">
                              {t("Carts")}
                            </p>
                            <Radio.Group
                              name="number_of_carts"
                              onChange={handleCartChange}
                              value={bookingState.powerCartAmount}
                            >
                              <Radio.Button
                                value={0}
                                disabled={
                                  teeOnPortalState?.selectedTeeTime?.teeTime?.cart_rule === "required" || bookingFeePaid
                                    ? true
                                    : false
                                }
                              >
                                {t("Walking")}
                              </Radio.Button>
                              <Radio.Button disabled={bookingFeePaid} value={1}>
                                {t("1 Cart")}
                              </Radio.Button>
                              <Radio.Button disabled={bookingFeePaid} value={2}>
                                {t("2 Carts")}
                              </Radio.Button>
                            </Radio.Group>
                          </div>
                        </div>
                      </Card.Section>
                    )}
                  </div>
                ) : null}

                <Card.Section>
                  <p className="tee-on-booking-portal-booking-booking-details-selection-title">{t("Golfers")}</p>
                  {[...Array(teeOnPortalState?.selectedTeeTime?.teeTime?.quantity_remaining)]?.map((num, index) => {
                    if (bookingState.bookingParticipants[index]) {
                      return (
                        <GolferCard
                          bookingEngineCard={true}
                          closable={index > 0 && !bookingFeePaid}
                          removeGolfer={() => removeGolferFromBooking(index)}
                          name={bookingState.bookingParticipants[index]?.full_name}
                          key={index}
                        />
                      );
                    } else if (index + 1 <= bookingState?.golferAmount) {
                      const searchResultKey = "friendsSearchResult".concat((index + 1).toString());
                      return (
                        <div key={index} className="new-player-sheet">
                          <Select
                            showSearch
                            onSearch={(query: string) =>
                              teeOnPortalState?.selectedTeeTime?.teeTime?.league_id
                                ? searchLeagueParticipant(query, index)
                                : handleCustomerSearch(query, "player".concat((index + 1).toString()))
                            }
                            onChange={(id: number, friendObject: ICustomerFriend) =>
                              teeOnPortalState?.selectedTeeTime?.teeTime?.league_id
                                ? handleLeagueParticipantSelection(id, friendObject)
                                : handleCustomerSelection(id, friendObject)
                            }
                            allowClear
                            searchValue={
                              teeOnPortalState?.selectedTeeTime?.teeTime?.league_id
                                ? bookingState[`leagueParticipantQuery_${index + 1}`]
                                : bookingState["player".concat((index + 1).toString())]
                            }
                            showDropDownOnFocus={!teeOnPortalState?.selectedTeeTime?.teeTime?.league_id ? true : false}
                            searching={bookingState.searching}
                            placeholder={t("Guest")}
                            disabled={index + 1 <= bookingState.golferAmount && !bookingFeePaid ? false : true}
                          >
                            {!teeOnPortalState?.selectedTeeTime?.teeTime?.league_id && (
                              <div className="ui-select-dropdown-list-item" onClick={displayAddPlayerModal}>
                                {"Add New Playing Partner"}
                              </div>
                            )}
                            {teeOnPortalState?.selectedTeeTime?.teeTime?.league_id
                              ? bookingState?.leagueParticipantList
                                  ?.filter(filteredParticipant =>
                                    filteredParticipant?.customer?.full_name
                                      ?.toLowerCase()
                                      .includes(bookingState[`leagueParticipantQuery_${index + 1}`]?.toLowerCase()),
                                  )
                                  ?.map((participant, index) => (
                                    <Option key={index} value={participant.user_id} extraValues={participant}>
                                      <span>{participant?.customer?.full_name}</span>
                                    </Option>
                                  ))
                              : renderFriendsList(searchResultKey)?.map((friend: ICustomerFriend, index: number) => {
                                  return (
                                    <Option key={index} value={friend.id} extraValues={friend}>
                                      <span>{friend.full_name}</span>
                                    </Option>
                                  );
                                })}
                          </Select>
                        </div>
                      );
                    }
                  })}
                </Card.Section>
              </Card>

              {windowSize.width > MOBILE_WIDTH && (
                <ClientPortalBookingCard
                  bookingState={bookingState}
                  paymentState={paymentState}
                  handleCardDropDownChange={handleCardDropDownChange}
                  openNewCardModal={openNewCardModal}
                  handleCheckboxChange={handleCheckboxChange}
                  returnToHomePage={deleteLock => void returnToHomePage(deleteLock)}
                  disableCheckout={disableCheckout}
                  displayPrePaidWarning={displayPrePaidWarning}
                  displayBookingFeeWarning={displayBookingFeeWarning}
                  checkFriendsToAdd={() => void checkFriendsToAdd()}
                  displayTerms={displayTerms}
                  bookingFeePaid={bookingFeePaid}
                  facilityLongName={teeOnPortalState?.selectedTeeTime?.facility?.long_name}
                  teeTime={teeOnPortalState?.selectedTeeTime?.teeTime}
                />
              )}
            </div>
            <div className="tee-on-booking-portal-booking-main-container-right-side">
              <div className="tee-on-booking-portal-booking-order-summary">
                <Card>
                  <Card.Section>
                    <p className="tee-on-booking-portal-booking-booking-details-selection-title">{"Order Summary"}</p>
                    {orderSummaryObjects?.map((summaryObject, index) => {
                      return (
                        <OrderSummaryLineItem
                          key={index}
                          lineItem={summaryObject.lineItem}
                          itemValue={summaryObject.itemValue}
                        />
                      );
                    })}
                    <br />
                    {bookingState.loadPutCart || bookingState.cart === null ? (
                      <div className="h-8 mt-2 flex justify-center">
                        <Spin className="self-center" />
                      </div>
                    ) : (
                      <>
                        <p>{t("Items")}</p>
                        {bookingState.cart?.line_items?.map((lineItem: Record<string, any>, index: number) => {
                          return (
                            <OrderSummaryLineItem
                              key={index}
                              lineItemQuantity={lineItem.quantity}
                              lineItem={lineItem.product_title}
                              lineItemVariant={lineItem.variant_title}
                              prepaid={lineItem.pre_paid_required}
                              itemValue={
                                <LocaleCurrency
                                  currency={bookingState.cart?.currency}
                                  amount={lineItem.subtotal_price}
                                />
                              }
                            />
                          );
                        })}
                        <br />

                        <OrderSummaryLineItem
                          lineItem={"Subtotal"}
                          itemValue={
                            <LocaleCurrency
                              currency={bookingState.cart?.currency}
                              amount={bookingState.cart?.subtotal_price}
                            />
                          }
                        />

                        {bookingState?.cart?.tax_lines?.map((taxLine: ITaxLine, index: number) => {
                          return (
                            <OrderSummaryLineItem
                              key={index}
                              lineItem={taxLine?.title ?? "Tax"}
                              itemSubtitle={taxLine?.rate ? `${100 * taxLine?.rate}%` : undefined}
                              itemValue={
                                <LocaleCurrency currency={bookingState.cart?.currency} amount={taxLine?.price} />
                              }
                            />
                          );
                        })}

                        <OrderSummaryLineItem
                          lineItem={"Total"}
                          itemValue={
                            <LocaleCurrency
                              currency={bookingState.cart?.currency}
                              amount={bookingState.cart?.total_price}
                            />
                          }
                        />

                        <br />
                        <p className="tee-on-booking-portal-booking-order-summary-total-text">{"Due at Course"}</p>
                        <p className="tee-on-booking-portal-booking-order-summary-total-price">
                          <LocaleCurrency
                            currency={bookingState.cart?.currency}
                            amount={
                              bookingState?.cart?.total_price_due
                                ? bookingState.cart?.total_price - bookingState.cart?.total_price_due
                                : bookingState.cart?.total_price
                            }
                          />
                        </p>
                        {bookingState?.cart?.total_price_due ? (
                          <>
                            <br />
                            <p className="tee-on-booking-portal-booking-order-summary-total-text">{"Total Due Now"}</p>
                            <p className="tee-on-booking-portal-booking-order-summary-total-price">
                              <LocaleCurrency
                                currency={bookingState.cart?.currency}
                                amount={bookingState.cart?.total_price_due}
                              />
                            </p>
                          </>
                        ) : null}
                      </>
                    )}
                  </Card.Section>
                  {teeOnPortalState?.selectedTeeTime?.facility?.teeSheetSettings?.booking_terms &&
                    windowSize.width > MOBILE_WIDTH && (
                      <Card.Section title={t("Booking Terms")}>
                        <Markdown
                          markdownText={teeOnPortalState?.selectedTeeTime?.facility?.teeSheetSettings?.booking_terms}
                        />
                      </Card.Section>
                    )}
                </Card>
                {windowSize.width <= MOBILE_WIDTH && (
                  <ClientPortalBookingCard
                    bookingState={bookingState}
                    paymentState={paymentState}
                    handleCardDropDownChange={handleCardDropDownChange}
                    openNewCardModal={openNewCardModal}
                    handleCheckboxChange={handleCheckboxChange}
                    returnToHomePage={deleteLock => void returnToHomePage(deleteLock)}
                    disableCheckout={disableCheckout}
                    displayPrePaidWarning={displayPrePaidWarning}
                    displayBookingFeeWarning={displayBookingFeeWarning}
                    checkFriendsToAdd={() => void checkFriendsToAdd()}
                    displayTerms={displayTerms}
                    bookingFeePaid={bookingFeePaid}
                    facilityLongName={teeOnPortalState?.selectedTeeTime?.facility?.long_name}
                    teeTime={teeOnPortalState?.selectedTeeTime?.teeTime}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Add new credit card modal */}

        <Panel
          open={bookingState.newCardActive && windowSize.width < MOBILE_WIDTH}
          onClose={closeAddNewCard}
          title={t("Add New Credit Card")}
          animate
          primaryAction={{
            onClick: () => void handleAddNewCard(),
            label: t("Add Card"),
            disabled: !elementsComplete,
          }}
          secondaryAction={{
            onClick: closeAddNewCard,
            label: t("Cancel"),
          }}
        >
          <div>
            <Form>
              <FormLayout>
                <FormLayout.Group>
                  {windowSize.width < MOBILE_WIDTH && <CardSection onChange={handleCardSectionChange} type="one-row" />}
                </FormLayout.Group>
                <FormLayout.Group>
                  <Checkbox
                    id="saveCard"
                    size="small"
                    onChange={handleCheckboxChange}
                    label={t("Save card for future bookings")}
                  />
                </FormLayout.Group>
              </FormLayout>
            </Form>
          </div>
        </Panel>

        <Sheet
          size="small"
          height="flexible"
          open={bookingState.newCardActive && windowSize.width > MOBILE_WIDTH}
          closable
          title={t("Add New Credit Card")}
          cancelText={t("Cancel")}
          okText={t("Add Card")}
          onOk={handleAddNewCard}
          okDisabled={!elementsComplete ? true : false}
          onCancel={closeAddNewCard}
          backDropCancel={false}
        >
          <div>
            <Form>
              <FormLayout>
                <FormLayout.Group>
                  {windowSize.width > MOBILE_WIDTH && <CardSection onChange={handleCardSectionChange} type="one-row" />}
                </FormLayout.Group>
                <FormLayout.Group>
                  <Checkbox
                    id="saveCard"
                    size="small"
                    onChange={handleCheckboxChange}
                    label={t("Save card for future bookings")}
                  />
                </FormLayout.Group>
              </FormLayout>
            </Form>
          </div>
        </Sheet>

        {/* Payment Terms Modal */}
        <Sheet
          size="small"
          height="flexible"
          open={bookingState.paymentTermsActive && windowSize.width > MOBILE_WIDTH}
          closable
          title={t("Payment Terms and Conditions")}
          cancelText={t("Close")}
          okText={t("Accept")}
          onOk={() => updateBookingState({ paymentTermsActive: false, acceptTerms: true })}
          onCancel={() => updateBookingState({ paymentTermsActive: false })}
          backDropCancel={false}
        >
          <Markdown markdownText={teeOnPortalState?.selectedTeeTime?.facility?.teeSheetSettings?.payment_terms} />
        </Sheet>

        <Panel
          open={bookingState.paymentTermsActive && windowSize.width <= MOBILE_WIDTH}
          onClose={() => updateBookingState({ paymentTermsActive: false })}
          title={`${teeOnPortalState?.selectedTeeTime?.facility?.long_name} Terms and Conditions`}
          animate
          primaryAction={{
            onClick: () => updateBookingState({ paymentTermsActive: false, acceptTerms: true }),
            label: t("Accept"),
          }}
          secondaryAction={{
            onClick: () => updateBookingState({ paymentTermsActive: false }),
            label: t("Close"),
          }}
        >
          <Markdown markdownText={teeOnPortalState?.selectedTeeTime?.facility?.teeSheetSettings?.payment_terms} />
          <br />
          <Markdown markdownText={teeOnPortalState?.selectedTeeTime?.facility?.teeSheetSettings?.booking_terms} />
        </Panel>

        {/* Add playing partner Modal */}
        <Panel
          open={bookingState.addPlayerModalVisible && windowSize.width < MOBILE_WIDTH}
          onClose={displayAddPlayerModal}
          title={t("Add Playing Partners")}
          animate
          primaryAction={{
            onClick: () => handleCustomerSelection(bookingState.selectedNewPlayer?.id, bookingState.selectedNewPlayer),
            label: t("Add Player"),
            disabled: bookingState.selectedNewPlayer ? false : true,
          }}
          secondaryAction={{
            onClick: displayAddPlayerModal,
            label: t("Cancel"),
          }}
        >
          {bookingState.selectedNewPlayer ? (
            <GolferCard
              closable
              removeGolfer={() => removeNewPlayerSelection()}
              name={bookingState.selectedNewPlayer?.full_name}
              email={bookingState.selectedNewPlayer?.email}
              bookingEngineCard={true}
            />
          ) : (
            <>
              <div className="tee-on-booking-portal-booking-search-player-label-container">
                <p className="text-sm text-subdued">{t('Search for public players using an email or phone number')}</p>
                <p className="text-sm text-subdued">{t('Search for members using their name, email or phone number')}</p>
              </div>
              <Select
                showSearch
                onSearch={(query: string) => handleCustomerSearch(query, "newPlayerQuery")}
                onChange={(id: string, friendObject: ICustomerFriend) => handleNewPlayerSelection(id, friendObject)}
                allowClear
                searchValue={bookingState.newPlayerQuery}
                searching={bookingState.searching}
                placeholder={t("Search...")}
                noData={
                  <div className="no-players-found">
                    <FontAwesomeIcon icon={faUsersSlash} fixedWidth size="1x" />
                    <span>{"No player found.."}</span>
                  </div>
                }
              >
                {bookingState.customerSearchResult?.map((friend, index) => {
                  return (
                    <Option key={index} value={friend.id} extraValues={friend} name={friend?.full_name}>
                      <span>
                        {friend.full_name} - {friend?.customer_type[0]?.title}
                      </span>
                    </Option>
                  );
                })}
              </Select>
            </>
          )}
        </Panel>

        <Sheet
          open={bookingState.addPlayerModalVisible && windowSize.width > MOBILE_WIDTH}
          size="small"
          height="flexible"
          closable
          title={t("Add New Playing Partner")}
          onCancel={displayAddPlayerModal}
          onOk={() => handleCustomerSelection(bookingState.selectedNewPlayer?.id, bookingState.selectedNewPlayer)}
          cancelText={t("Cancel")}
          okText={t("Add Player")}
          okDisabled={bookingState.selectedNewPlayer ? false : true}
          overflow
        >
          {bookingState.selectedNewPlayer ? (
            <GolferCard
              closable
              removeGolfer={() => removeNewPlayerSelection()}
              name={bookingState.selectedNewPlayer?.full_name}
              email={bookingState.selectedNewPlayer?.email}
              bookingEngineCard={true}
            />
          ) : (
            <>
              <div className="tee-on-booking-portal-booking-search-player-label-container">
                <p className="text-sm text-subdued">{t('Search for public players using an email or phone number')}</p>
                <p className="text-sm text-subdued">{t('Search for members using their name, email or phone number')}</p>
              </div>
              <Select
                showSearch
                onSearch={(query: string) => handleCustomerSearch(query, "newPlayerQuery")}
                onChange={(id: string, friendObject: ICustomerFriend) => handleNewPlayerSelection(id, friendObject)}
                allowClear
                searchValue={bookingState.newPlayerQuery}
                searching={bookingState.searching}
                placeholder={t("Search...")}
                noData={
                  <div className="no-players-found">
                    <FontAwesomeIcon icon={faUsersSlash} fixedWidth size="1x" />
                    <span>{"No player found.."}</span>
                  </div>
                }
              >
                {bookingState.customerSearchResult?.map((friend, index) => {
                  return (
                    <Option key={index} value={friend.id} extraValues={friend} name={friend?.full_name}>
                      <span>
                        {friend.full_name} - {friend?.customer_type[0]?.title}
                      </span>
                    </Option>
                  );
                })}
              </Select>
            </>
          )}
        </Sheet>

        {/* Add friends modal */}
        <Sheet
          size="small"
          height="flexible"
          open={addFriendState?.modalVisible}
          closable
          title={t("Add Playing Partners")}
          okText={t("Confirm and Book")}
          onOk={handleAddFriends}
          onCancel={() =>
            setAddFriendState(prevState => ({
              ...prevState,
              friendsToAdd: [],
              modalVisible: false,
              selectedPlayerIds: [],
            }))
          }
          backDropCancel={false}
          stacked
        >
          <div className="tee-on-booking-portal-booking-add-playing-partners">
            <p className="confirmation-text">
              {t('Would you like to add the following golfers to your playing partners list?')}
            </p>
            {addFriendState?.friendsToAdd?.map((participant: ICustomerFriend, index) => {
              return (
                <div
                  key={index}
                  className="add-player-container"
                  onClick={() => handleAddPlayerCheckbox(participant?.id)}
                >
                  <div className="add-player-checkbox">
                    <Checkbox
                      size="small"
                      checked={addFriendState?.selectedPlayerIds?.includes(participant?.id) ?? false}
                      onChange={() => handleAddPlayerCheckbox(participant?.id)}
                    />
                  </div>
                  <div className="player-image-container">
                    <div className="tee-on-booking-portal-profile-default-image">
                      <p>
                        {participant?.first_name?.charAt(0)?.toUpperCase()}
                        {participant?.last_name?.charAt(0)?.toUpperCase()}
                      </p>
                    </div>
                  </div>
                  <div className="player-info-conatiner">
                    <p className="player-name">{participant?.full_name}</p>
                    <p className="confirmation-text">{participant?.email}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </Sheet>

        <Popup
          open={prepaidWarning?.open}
          type="info"
          title={prepaidWarning?.title}
          description={prepaidWarning?.description}
          onCancel={() => setPrepaidWarning({ open: false, title: "", description: "" })}
          onOk={checkFriendsToAdd}
        />
      </>
    )
  );
}
